export const isDDMShowroom = () => {
  const metaTag = document.querySelector('meta[name="is_ddm_showroom"]');
  return !!metaTag;
};
